<template>
  <div class="step">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="体重" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column label="序号" width="80" align="center" type="index">
          </el-table-column>
          <el-table-column label="记录时间" align="center" prop="Day">
            <template slot-scope="scope" align="center">
              {{ scope.row.Time }}
            </template>
          </el-table-column>
          <el-table-column label="体重" align="center" prop="DeviceType">
            <template slot-scope="scope" align="center">
              {{ scope.row.Nweight || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="BMI" align="center" prop="CurrentStep">
            <template slot-scope="scope" align="center">
              {{ scope.row.BMI || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="等级" align="center" prop="CurrentStep">
            <template slot-scope="scope" align="center">
              {{ scope.row.grade || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          :page-size="size"
          @current-change="changefn"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { requestUserWeightData } from "@/api/userApi";
import { handtime } from "@/utils/util";
export default {
  name: "step",
  data() {
    return {
      activeName: "first",
      page: 1,
      size: 10,
      total: 0,
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created() {
    this.requestUserWeightDatafn();
  },
  filters: {
    handtime,
    handDay(time) {
      if (time == "-") {
        return "-";
      } else {
        return time.slice(0, 10);
      }
    },
  },
  methods: {
    changefn(index) {
      this.page = index;
      this.requestUserWeightDatafn();
    },
    async requestUserWeightDatafn() {
      var res = await requestUserWeightData({
        userId: this.$route.query.id,
        page: this.page,
        size: this.size,
      });
      var h = res.data.data.Nheight / 100;
      this.tableData = res.data.data.result.list.map((item) => {
        var BMI;
        var w = item.Nweight;
        if (h && w) {
          BMI = (w / (h * h)).toFixed(3);
        } else {
          BMI = "";
        }
        var grade = "";
        if (BMI) {
          if (BMI < 18.5) {
            grade = "偏瘦";
          } else if (BMI < 25) {
            grade = "标准";
          } else if (BMI < 30) {
            grade = "超重";
          } else if (BMI < 35) {
            return "肥胖";
          } else if (BMI < 40) {
            grade = "重度肥胖";
          } else {
            grade = "极重度肥胖";
          }
        }
        return {
          ...item,
          BMI,
          grade,
        };
      });
      console.log(this.tableData);
      this.total = res.data.data.result.count;
    },
  },
};
</script>

<style lang="less">
.step {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>
